import { addIcons } from 'ionicons';

const CUSTOM_ICONS_BASE = '/assets/custom-ion-icons';

function getPath(name: string): string {
  return `${ CUSTOM_ICONS_BASE }/${ name }.svg`;
}

export enum Icons {
  ASSET_BORDER_20PX = 'asset-border-20px',
  ASSET_CIRCLE = 'asset-circle',
  IC_SOCIAL_INSTAGRAM = 'ic-social-instagram',
  IC_SOCIAL_FACEBOOK = 'ic-social-facebook',
  IC_SOCIAL_YOUTUBE = 'ic-social-youtube',
  IC_SOCIAL_LINKEDIN = 'ic-social-linkedin',
  IC_SOCIAL_WHATSAPP = 'ic-social-whatsapp',
  IC_SOCIAL_TIKTOK = 'ic-social-tiktok',
  IC_ARROW_RIGHT = 'ic-arrow-right',
  IC_ARROW_RIGHT_SM = 'ic-arrow-right-sm',
  IC_ARROW_LEFT = 'ic-arrow-left',
  IC_ARROW_LEFT_SM = 'ic-arrow-left-sm',
  IC_CHEVRON_RIGHT = 'ic-chevron-right',
  IC_CHEVRON_DOWN = 'ic-chevron-down',
  IC_SIGN_OUT = 'ic-sign-out',
  IC_CLOSE = 'ic-close',
  IC_WARNING = 'ic-warning',
  IC_SHARE = 'ic-share',
  IC_DOWNLOAD = 'ic-download',
  IC_NOTIFICATION = 'ic-notification',
  IC_NOTIFICATION_SM = 'ic-notification-sm',
  IC_EMAIL = 'ic-email',
  IC_LOCK = 'ic-lock',
  IC_EYE_OFF = 'ic-eye-off',
  IC_EYE_ON = 'ic-eye-on',
  IC_USER = 'ic-user',
  IC_PHONE = 'ic-phone',
  IC_REAL_ESTATE = 'ic-real-estate',
  IC_REAL_ESTATE_PORTAL = 'ic-real-estate-portal',
  IC_ID_CARD = 'ic-id-card',
  IC_HOME = 'ic-home',
  IC_BUILDING = 'ic-building',
  IC_HEART = 'ic-heart',
  IC_HEART_FILLED = 'ic-heart-filled',
  IC_SETTINGS = 'ic-settings',
  IC_USER_CIRCLE = 'ic-user-circle',
  IC_LOCATION_PIN = 'ic-location-pin',
  IC_NEWS = 'ic-news',
  IC_CHAT = 'ic-chat',
  IC_EXTERNAL_LINK = 'ic-external-link',
  IC_MONEY = 'ic-money',
  IC_WORK = 'ic-work',
  IC_BED = 'ic-bed',
  IC_CLOCK = 'ic-clock',
  IC_STAIRS = 'ic-stairs',
  IC_CAR = 'ic-car',
  IC_FLOOR_PLAN = 'ic-floor-plan',
  IC_SQUARES = 'ic-squares',
  IC_PANORAMA = 'ic-panorama',
  IC_BOOK = 'ic-book',
  IC_DOCUMENT = 'ic-document',
  IC_MARKETING = 'ic-marketing',
  IC_GALLERY = 'ic-gallery',
  IC_TAG = 'ic-tag',
  IC_CHECK = 'ic-check',
  IC_QUESTION = 'ic-question',
  IC_STAR = 'ic-star',
  IC_SLIDERS = 'ic-sliders',
  IC_EDIT = 'ic-edit',
  IMG_EMPTY_FOLDER = 'img-empty-folder',
  IMG_HOME = 'img-home',
  IMG_MAILBOX = 'img-mailbox',
  IMG_NOTIFICATION = 'img-notification',
  IMG_ONBOARDING_1 = 'img-onboarding-1',
  IMG_ONBOARDING_2 = 'img-onboarding-2',
  IMG_ONBOARDING_3 = 'img-onboarding-3',
  IMG_RESET_PASSWORD = 'img-reset-password',
  IMG_UNDER_REVIEW = 'img-under-review',
  LOGO_TARRAF = 'logo-tarraf',
  LOGO_TARRAF_IMOB = 'logo-tarraf-imobiliarias',
}

export const customIcons: Record<string, string> =
    Object.fromEntries(
        Object.values(Icons)
              .map((name) => [name, getPath(name)]),
    );

export function registerCustomIcons(): void {
  addIcons(customIcons);
}
